import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { TDevice } from "../../../types/Devices";
import { CONFIG } from "../../../constants/config";

const DeviceDetailModalMap = ({
  selectedDevice,
  style = { height: "500px" },
  className,
}: {
  selectedDevice: TDevice;
  style?: Record<string, unknown>;
  className?: string;
}) => (
  <APIProvider apiKey={CONFIG.GOOGLE_API_KEY || ""}>
    <Map
      className={className}
      style={className ? undefined : style}
      defaultCenter={{
        lat: selectedDevice.lat * 1,
        lng: selectedDevice.lon * 1,
      }}
      defaultZoom={15}
      gestureHandling={"greedy"}
      disableDefaultUI={true}
    >
      <Marker
        position={{
          lat: selectedDevice.lat * 1,
          lng: selectedDevice.lon * 1,
        }}
      />
    </Map>
  </APIProvider>
);
export default DeviceDetailModalMap;
